import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2, Calendar, Clock, Droplets, Home } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function WashConfirmationPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [bookingId, setBookingId] = useState('');

  const sessionId = searchParams.get('session_id');
  const bookingIdParam = searchParams.get('booking_id');

  useEffect(() => {
    if (sessionId && bookingIdParam) {
      confirmPayment();
    } else {
      setStatus('error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, bookingIdParam]);

  const confirmPayment = async () => {
    try {
      const res = await fetch(`${API}/wash/confirm-payment?session_id=${sessionId}&booking_id=${bookingIdParam}`);
      if (res.ok) {
        setStatus('success');
        setBookingId(bookingIdParam);
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center py-12 px-4">
      <Card className="w-full max-w-lg bg-zinc-900/50 border-zinc-800">
        <CardContent className="p-8 text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="mx-auto text-blue-500 animate-spin mb-4" size={64} />
              <h2 className="text-2xl font-bold text-white mb-2">Confirmation en cours...</h2>
              <p className="text-zinc-400">Veuillez patienter pendant que nous confirmons votre paiement.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="text-green-500" size={48} />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Paiement confirmé !</h2>
              <p className="text-zinc-400 mb-6">Votre réservation de lavage a été confirmée et payée.</p>
              
              <div className="bg-zinc-800/50 rounded-lg p-4 mb-6 text-left">
                <div className="flex items-center gap-3 mb-3">
                  <Droplets className="text-blue-400" size={24} />
                  <div>
                    <p className="text-white font-semibold">Lavage réservé</p>
                    <p className="text-zinc-500 text-sm">Réf: {bookingId.slice(0, 8)}...</p>
                  </div>
                </div>
                <p className="text-green-400 text-sm">
                  <CheckCircle size={14} className="inline mr-1" />
                  Une facture a été générée dans votre espace client
                </p>
              </div>

              <div className="space-y-3">
                <Link to="/mon-compte" className="block">
                  <Button className="w-full bg-green-600 hover:bg-green-700">
                    <Calendar size={18} className="mr-2" />
                    Voir mes réservations
                  </Button>
                </Link>
                <Link to="/" className="block">
                  <Button variant="outline" className="w-full border-zinc-700">
                    <Home size={18} className="mr-2" />
                    Retour à l'accueil
                  </Button>
                </Link>
              </div>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <XCircle className="text-red-500" size={48} />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Erreur de confirmation</h2>
              <p className="text-zinc-400 mb-6">
                Une erreur est survenue lors de la confirmation de votre paiement. 
                Veuillez contacter notre équipe si le problème persiste.
              </p>
              
              <div className="space-y-3">
                <Link to="/reservation-lavage" className="block">
                  <Button className="w-full bg-red-600 hover:bg-red-700">
                    Réessayer
                  </Button>
                </Link>
                <Link to="/contact" className="block">
                  <Button variant="outline" className="w-full border-zinc-700">
                    Contacter le support
                  </Button>
                </Link>
              </div>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
